import { render, staticRenderFns } from "./CategoriaTable.vue?vue&type=template&id=3a18117e"
import script from "./CategoriaTable.vue?vue&type=script&lang=js"
export * from "./CategoriaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports